export default __webpack_public_path__ + "static/media/HDTX_Audit Report 2023.20392e5d.pdf";